import { NgModule, InjectionToken } from '@angular/core';

export let APP_CONFIG = new InjectionToken<AppConfig>('app.config');

// TODO: get rid of warnings by splitting interface out into separate file
// export interface AppConfig {
export class AppConfig {
  wpApiEndpoint: string;
  signUpEndpoint: string;
}

export const APP_DI_CONFIG: AppConfig = {
  wpApiEndpoint: 'http://resources.buyersclubhq.com/wp-json/wp/v2/',
  signUpEndpoint: 'https://buyersclubhq.com/signup'
};

@NgModule({
  providers: [{
    provide: APP_CONFIG,
    useValue: APP_DI_CONFIG
  }]
})
export class AppConfigModule { }

